// Votre « peps » des boutons d'action selon le module (couleur de l'expert Happn) : jaune Sophie · menthe Léo · rose Théo · lavande Manu · ciel Clara.
const MAP = [
  [/\/(stocks|commandes|achats|fournisseurs|catalogue|inventaire|livraisons|receptions|connecteurs-caisse)(\/|$|\?)/, 'sun'],
  [/\/(fiches|cartes|menus|marge|recettes|boissons|packaging|materiel|equipements)(\/|$|\?)/, 'mint'],
  [/\/(finance|ventes|gratuites|facturation|tresorerie|charges|objectifs|strategie)(\/|$|\?)/, 'pink'],
  [/\/(planning|equipe|taches|conges|recrutement|arrivees|evaluation|primes|formation|onboarding|basecamp|haccp|hygiene)(\/|$|\?)/, 'lav'],
  [/\/(social|reseaux|digital|avis|studio|contenus|site|reputation|inbox)(\/|$|\?)/, 'sky'],
];
export const pepFor = (pathname = '') => (MAP.find(([re]) => re.test(pathname)) || [null, 'sun'])[1];
